import type { AuthService } from "./auth-service";
import { AuthServiceBronze } from "./auth-service-bronze";
import { AuthServiceGold } from "./auth-service-gold";
import { AuthServicePlatinum } from "./auth-service-platinum";
import { AuthServiceSilver } from "./auth-service-silver";
import { AuthServiceUnauthenticated } from "./auth-service-unauthenticated";
import { type UserRole, UserRoles } from "./user-roles";

export const getAuthService = (roles: UserRole[] | null): AuthService => {
	if (!roles) {
		return new AuthServiceUnauthenticated();
	}
	if (roles.includes(UserRoles.PLATINUM)) {
		return new AuthServicePlatinum();
	}
	if (roles.includes(UserRoles.GOLD)) {
		return new AuthServiceGold();
	}
	if (roles.includes(UserRoles.SILVER)) {
		return new AuthServiceSilver();
	}
	return new AuthServiceBronze();
};
